var URL;
(function (URL) {
    URL["LINKEDIN"] = "https://www.linkedin.com/in/sukrutn/";
    URL["YOUTUBE"] = "https://drive.google.com/file/d/1XH5ZH4kbPkcBAgDZD2b4opoG1s6RPWDt/view?usp=sharing";
    URL["GITHUB"] = "https://github.com/SukrutN";
    URL["MERCADOLIBRE"] = "https://www.mercadolibre.com.ar";
    URL["GCBA"] = "https://www.buenosaires.gob.ar";
    URL["WAYNE"] = "https://wayne.edu/";
    URL["MAIL"] = "sukrutnadigotti@gmail.com";
    URL["BOOKGEMS"] = "https://github.com/SukrutN/bookgems";
    URL["CHITCHAT"] = "https://github.com/SukrutN/chitchat";
    URL["HRM"] = "https://github.com/SukrutN/ECG-and-Heart-Rate-Monitor";
    URL["PIXELPAINT"] = "https://github.com/SukrutN/pixelpaint";
    URL["PORTFOLIO"] = "https://github.com/Sukrutbasanta/portfolio";
    URL["TROPHYTRACKER"] = "https://github.com/WSU-4110/TrophyTracker";
    URL["TASKMANAGER"] = "https://github.com/SukrutN/ChapterOne";
    URL["COMMUNITYCONNECT"] = "https://www.communityconnect.cc/";
    URL["ENSONO"] = "https://www.ensono.com/";
})(URL || (URL = {}));
export default URL;
